export default __webpack_public_path__ + "44b5cd90c42c0b386f98dc66a6acbb21.png";